import React from 'react';

class FieldMandatory extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      conditionallyDisplayed: props.conditionallyDisplayed,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {conditionallyDisplayed: nextProps.conditionallyDisplayed};
  }

  updateValue(value) {
    this.setState(
      { value },
      () => this.props.onChange(this.state.value)
    );
  }

  render() {
    return <div className="form-check mb-3">
      <input id={this.props.id + 'Mandatory'}
             name={this.props.id + 'Mandatory'}
             type="checkbox"
             className="form-check-input"
             checked={!!this.state.value}
             onChange={e => this.updateValue(e.target.checked)} />
      <label className="form-check-label" htmlFor={this.props.id + 'Mandatory'}>
        Mandatory{this.state.conditionallyDisplayed ? ' (only when displayed)' : ''}
      </label>
      {this.props.helpBlock &&
      <div className="form-text">{this.props.helpBlock}</div>
      }
    </div>
  }

}

export default FieldMandatory;
